
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
//import { isObjectEmpty } from '../../utils';
import { withStyles } from '@material-ui/core/styles';
import { documentStyles } from '../../Styles/documentStyles';
import Images from '../../Theme/Images';
import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputAdornment from '@material-ui/core/InputAdornment';
import { ReactSVG } from 'react-svg'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Button from '@material-ui/core/Button';
import Loader from 'react-loader-spinner'
import DocumentDrawer from './DocumentDrawer';
import IdleTimer from 'react-idle-timer';
import SubmitDialog from './SubmitDialog';
import { Scrollbars } from 'react-custom-scrollbars';

@inject('documentStore', 'dashboardStore')
@observer
class DocumentForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            validationErrors: {},
            openSubmitDialog: false,
            currentField: ''
        }
        this._areaElement = new Map();
        this._areaElementBack = new Map();
    }


    handleFormFieldChange = (value, index, fieldId, type) => {
        this.props.documentStore.updateField(value, index, fieldId, type)
    }

    ntn = () => {

    }

    getFormFields = (item, index) => {
        const { validationErrors } = this.state;
        const { classes } = this.props;
        const { imageFacingSide, currentPage } = this.props.documentStore;
        switch ('text') {
            case 'text':
                return (
                    <ListItem key={index} style={{ paddingTop: 0, marginTop: 0 }}>
                        <TextField
                            coords={item.pts.slice()}
                            ref={c => this._areaElement.set(index, c)}
                            onClick={(e) => this.setCurrentField(e, index, item)}
                            //onMouseOver={imageFacingSide ? this.ntn : (e) => this.props.highlight(e, index)}
                            //onMouseOut={imageFacingSide ? this.ntn : (e) => this.props.removeHighlight(e, index)}
                            color="primary"
                            style={{ paddingTop: 0, marginTop: 0 }}
                            required
                            id={item.label}
                            key={item._id}
                            label={item.label}
                            type={item.type}
                            margin="normal"
                            variant="filled"
                            fullWidth
                            InputProps={{
                                disableUnderline: true,
                                endAdornment:
                                    <InputAdornment position="end">
                                        {currentPage.formData[index].progressIcon}
                                    </InputAdornment>

                            }}
                            value={item.editedValue !== "" ? item.editedValue : item.aiValue}
                            onChange={(event) => this.handleFormFieldChange(event.target.value, index, item._id, item.editedValue !== "" ? "editedValue" : "aiValue")}
                        />

                        {validationErrors[item.label] && <FormHelperText id={item.label}>{validationErrors[item.label]}</FormHelperText>}
                    </ListItem>
                )
        }
    }

    openDropDown = () => {
        this.props.documentStore.openDocumentDrawer()
    }

    onSubmit = (finalSubmit, autoSave, next) => {
        const { currentDoc, currentPage } = this.props.documentStore;
        if (!next && !autoSave)
            this.setState({ openSubmitDialog: true })
        else
            this.props.documentStore.updateDocument(finalSubmit, next)
    }

    cancelSubmit = () => {
        this.setState({ openSubmitDialog: false })
    }

    downloadDoc = (doc) => {
        this.props.documentStore.exportXls(doc._id)
    }

    onCancel = () => {
        const { currentDoc } = this.props.documentStore;
        if (currentDoc.docStatus === "REVIEW_PENDING")
            this.props.history.push("/dashboard/drafts");
        else if (currentDoc.docStatus === "REVIEW_COMPLETE")
            this.props.history.push("/dashboard/reviewed");
        else
            this.props.history.push("/dashboard/exported");
    }

    save = () => {
        //this.onSubmit(false, true, false);
    }

    setCurrentField = (e, index, item) => {
        this.setState({
            currentField: index
        })
        this.props.documentStore.setCurrentField(item, index)
        this.props.highlight(e, index)
    }

    exportDoc = () => {
        const { currentDoc } = this.props.documentStore;
        let temp = [];
        temp.push(currentDoc._id);
        this.props.dashboardStore.exportXls(temp, 'EXPORTED')

    }

    componentWillUnmount() {
        this.props.removeHighlight(undefined, this.props.documentStore.currentIndex)
    }

    changePage = (type) => {
        const { currentPage, currentDoc } = this.props.documentStore;
        let index = currentDoc.pageArray.findIndex(x => x._id === currentPage._id);
        this.props.resetImage()
        if (type === '-')
            this.props.documentStore.setCurrentImage(currentDoc.pageArray[index - 1], index - 1);
        else
            this.props.documentStore.setCurrentImage(currentDoc.pageArray[index + 1], index + 1);
    }

    finalSubmit = () => {
        this.props.documentStore.updateDocument(true, false)
        .then((resp) =>{
            if(!this.props.documentStore.updateProgress)
                this.onCancel()
        })
    }


    render() {
        const { classes } = this.props;
        const { currentPage, currentDoc, inProgress, updateProgress } = this.props.documentStore;
        return (
            <div className={classes.formDiv}>
                <div onMouseOver={(e) => this.openDropDown()} style={{ height: '1vh' }}></div>
                <div className={classes.headerContainer}>
                    <div className={classes.docHeader}>{currentDoc.originalFileName}
                        {<KeyboardArrowDownIcon className={classes.dropDownIcon} onClick={(e) => this.openDropDown()}></KeyboardArrowDownIcon>}
                    </div>
                    {currentDoc.pageArray[currentDoc.pageArray.length - 1]._id === currentPage._id && currentPage.reviewed ? <ReactSVG src={Images.exportSingle} onClick={(e) => this.exportDoc()} beforeInjection={svg => { svg.classList.add(classes.svg) }} /> : null}
                </div>
                <IdleTimer ref="saveTimer" onAction={this.save} debounce={1000} timeout={10000} startOnLoad={false} >
                    <form noValidate autoComplete="off" className={classes.formStyle}>
                    <div style={{overflowY: 'scroll', height: '68vh'}}>
                        <List>
                            {
                                currentPage && currentPage.formData.map((item, index) => {
                                    return this.getFormFields(item, index)
                                })
                            }
                        </List>
                        </div>
                    </form>
                </IdleTimer>
                <div className={classes.formSubmitContainer}>
                    <div>
                        {
                            currentDoc.pageArray[currentDoc.pageArray.length - 1]._id === currentPage._id ?
                                (updateProgress ?
                                    <Button variant="contained" className={classes.submitButton} fullWidth>
                                        <Loader height={30} width={30} color={this.props.theme.palette.white} />
                                    </Button>
                                    : <Button onClick={(event) => this.onSubmit(true, false, false)} variant="contained" className={classes.submitButton} type="submit" fullWidth>
                                        Submit
                                    </Button>) :
                                <Button onClick={(event) => this.onSubmit(true, false, true)} variant="contained" className={classes.submitButton} type="submit" fullWidth>
                                    Submit
                        </Button>

                        }
                        <Button onClick={(event) => this.onCancel()} variant="contained" style={{ backgroundColor: this.props.theme.palette.dark }} className={classes.submitButton} type="submit" fullWidth>
                            Cancel
                        </Button>
                    </div>
                    <div className={classes.pageAction} >
                        {currentDoc.pageArray.findIndex(x => x._id === currentPage._id) - 1 >= 0 ?
                            <ReactSVG className={classes.navIcons} src={Images.backArrow} onClick={(e) => this.changePage('-')} /> :
                            <ReactSVG className={classes.navIcons} src={Images.backArrowInactive} />
                        }
                        {currentDoc.pageArray[currentDoc.pageArray.length - 1]._id === currentPage._id ?
                            <ReactSVG className={classes.navIcons} src={Images.nextArrowInactive} /> :
                            <ReactSVG className={classes.navIcons} src={Images.nextArrow} onClick={(event) => this.changePage('+')} />
                        }
                    </div>
                    {currentDoc.exportUrl !== undefined ?
                        <Button variant="contained" className={classes.submitButton} type="submit" onClick={(event) => { this.downloadDoc(currentDoc) }} fullWidth>
                            Download
                        </Button> : null
                    }
                </div>
                <SubmitDialog open={this.state.openSubmitDialog} cancelSubmit={this.cancelSubmit} submit={this.finalSubmit}></SubmitDialog>
            </div>

        )
    }
}
export default withStyles(documentStyles, { withTheme: true })(withRouter(DocumentForm));
